// extracted by mini-css-extract-plugin
export var container = "DeliveryNotes-module--container--VMVim";
export var content = "DeliveryNotes-module--content--183Kv";
export var dateField = "DeliveryNotes-module--dateField--hee3R";
export var datePicker = "DeliveryNotes-module--datePicker--BIuny";
export var noOrders = "DeliveryNotes-module--noOrders--ufVht";
export var searchInput = "DeliveryNotes-module--searchInput--uYrwW";
export var subHeader = "DeliveryNotes-module--subHeader--UW6K5";